export default __webpack_public_path__ + "static/playground-fcafbfdc8edc581e6b145e892289e82b.jpg";